import { render } from "./notification-preferences.vue?vue&type=template&id=3b95a2db"
import script from "./notification-preferences.vue?vue&type=script&lang=js"
export * from "./notification-preferences.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__